module.exports = __webpack_public_path__ + "img/jin.47036e22.png";